import { useEffect, useRef } from 'react';

import { getLogger } from '../../libs/logger';
import { useNetworkConnectionStatus } from '../useNetworkConnectionStatus';

const logger = getLogger('useOnlineStatusBeacon');

export const useOnlineStatusBeacon = (): void => {
  const isNetworkOnline = useNetworkConnectionStatus();
  const onlineStatusChanged = useRef(false);

  useEffect(() => {
    if (onlineStatusChanged.current) {
      logger.info(
        `Online status changed: ${isNetworkOnline ? 'online' : 'offline'}`,
      );
    } else {
      onlineStatusChanged.current = true;
    }
  }, [isNetworkOnline]);
};
